// @flow

import $ from 'jquery'

export default class SeparatorLine {
  static separatorLine: Object
  static whiteBoxes: Object
  static navigation: Object
  static tickerHeight: number

  static _handleScroll () {
    let isBorderVisible = false
    const isFixed: boolean = SeparatorLine.navigation.hasClass('navigation-fixed')

    // SeparatorLine.tickerHeight +
    const additionalHeight = $('.child-menu:visible').outerHeight() - 44 || 0
    const offsetHeight: number = (isFixed ? SeparatorLine.navigation.outerHeight() + additionalHeight : 0)
    const scrollY: number = window.scrollY + offsetHeight

    SeparatorLine.whiteBoxes.each(function () {
      const { top }: { top: number } = $(this).offset()
      const bottom: number = top + $(this).outerHeight()

      if (top - scrollY < 0 && bottom - scrollY > 0) {
        isBorderVisible = true
      }
    })

    SeparatorLine.separatorLine.css('top', `${offsetHeight}px`)

    if (isBorderVisible) {
      SeparatorLine.separatorLine.show()
    }
    else {
      SeparatorLine.separatorLine.hide()
    }
  }

  static init () {
    SeparatorLine.separatorLine = $('.separator-line')
    SeparatorLine.whiteBoxes = $('.white-bg')
    SeparatorLine.navigation = $('#navigation')
    SeparatorLine.tickerHeight = $('.row.price-ticker').height()

    window.addEventListener('scroll', SeparatorLine._handleScroll)
    window.addEventListener('mousemove', SeparatorLine._handleScroll)

    SeparatorLine._handleScroll()
  }
}
